export const METRICS_ENDPOINT = 'https://qdbx3pbnx6veby23pzgaowu3q40tmmrr.lambda-url.us-east-1.on.aws';
export const STORAGE_KEY = 'APE_CW_METRICS';
export const BATCH_SIZE = 10;

export type PostMetricDTO = {
    metricName: string;
    timestamp?: number;
    count?: number;
    dimensions: Record<string, string>;
    xApiKey: string;
};

let unloadHookRegistered = false;

// Used for testing
export const resetUnloadHook = (): void => {
    unloadHookRegistered = false;
};

export const logMetric = (event: PostMetricDTO): void => {
    if (!unloadHookRegistered) {
        window.addEventListener('beforeunload', () => flushAndClear());
        unloadHookRegistered = true;
    }

    const cache = getCache();
    cache.push(event);

    if (cache.length >= BATCH_SIZE) {
        flushCache(cache);
    } else {
        updateCache(cache);
    }
};

const getCache = (): PostMetricDTO[] => {
    const data = localStorage.getItem(STORAGE_KEY);
    if (!data) return [];
    try {
        return JSON.parse(data) as PostMetricDTO[];
    } catch {
        return [];
    }
};

const flushCache = (metrics: PostMetricDTO[]): void => {
    navigator.sendBeacon(METRICS_ENDPOINT, JSON.stringify(metrics));
    localStorage.removeItem(STORAGE_KEY);
};

const updateCache = (metrics: PostMetricDTO[]): void => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(metrics));
};

const flushAndClear = (): void => {
    const cache = getCache();
    if (cache.length > 0) {
        flushCache(cache);
    }
};
